import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Rating } from '@mui/material';
import { Dish } from '../../types';
import { S3_DISH_PLACEHOLDER } from '../../config';

interface DishCarouselCardProps {
  dish: Dish;
  onClick: (dish: Dish) => void;
}

const DishCarouselCard: React.FC<DishCarouselCardProps> = ({ dish, onClick }) => {
  const imageUrl = dish.image_url || S3_DISH_PLACEHOLDER;

  return (
    <Card 
      sx={{ 
        minWidth: 280,
        maxWidth: 280,
        cursor: 'pointer',
        '&:hover': {
          transform: 'scale(1.02)',
          transition: 'transform 0.2s ease-in-out',
        },
      }}
      onClick={() => onClick(dish)}
    >
      <CardMedia
        component="img"
        height="140"
        image={imageUrl}
        alt={dish.name}
      />
      <CardContent>
        <Typography variant="h6" component="div" noWrap>
          {dish.name}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Rating value={dish.average_rating || 0} readOnly size="small" />
          <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
            {dish.average_rating?.toFixed(1) || 'No ratings'}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" noWrap>
          {dish.description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default DishCarouselCard; 